// extracted by mini-css-extract-plugin
module.exports = {"servicesHeader":"styles_servicesHeader__2Cj2M","services":"styles_services__14cUi","servicesList":"styles_servicesList__1e_Dl"};